import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ReactComponent as WarningIcon } from '../_images/exclamation-triangle.svg';
import GenericPopup from "./GenericPopup";

function PopupWarning({ show, text, onHide, onConfirm, icon }) {

    function getFooter() {
        return (
            <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                <Button variant="primary" onClick={() => onConfirm(true)}>
                    Ok
                </Button>
            </div>
        );
    }

    return (
        <GenericPopup show={show} text={text} onHide={onHide} onConfirm={onConfirm} icon={icon} footer={getFooter()} />
    )
}

export default PopupWarning
